import React from 'react';
import { getStatusBadgeClass, getEstadoBadgeClass } from '../../utils/formatters';

export const StatusBadge = ({ status }) => (
  <span className={getStatusBadgeClass(status)}>{status}</span>
);

export const EstadoBadge = ({ estado }) => (
  <span className={getEstadoBadgeClass(estado)}>{estado}</span>
);
